import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import { mobile } from 'styles/media';

const wrap: CSSObject = {
  width: '480px',
  maxWidth: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
};

const field: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  '> input:not([type=file]), > select': { width: '100%' },
};

const hint: CSSObject = {
  fontSize: 12,
  color: theme.color.textMuted,
};

const radios: CSSObject = {
  display: 'flex',
  gap: '0 16px',
};

const groupActions: CSSObject = {
  display: 'flex',
  gap: '0 6px',
  flexShrink: 0,
};

const footer: CSSObject = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '0 8px',
  marginTop: 8,
  [mobile]: {
    '> button': { flex: 1, height: 48 },
  },
};

export { wrap, field, hint, radios, groupActions, footer };
